var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMasternew12(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 25,
    viewBox: "0 0 54 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3497_34965)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.7579 12.1927C22.7579 8.96356 24.2664 6.08891 26.6151 4.2281C24.8831 2.85606 22.6953 2.03467 20.3143 2.03467C14.7043 2.03467 10.1562 6.58271 10.1562 12.1925C10.1562 17.8025 14.7041 22.3503 20.3143 22.3503C22.6953 22.3503 24.8831 21.5291 26.6151 20.1571C24.2664 18.2965 22.7579 15.4216 22.7579 12.1925V12.1927Z",
    fill: "#DE2C1D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.7578 12.1926C22.7578 15.422 24.2663 18.2966 26.615 20.1572C28.9637 18.2966 30.472 15.4218 30.472 12.1926C30.472 8.96348 28.9635 6.08884 26.615 4.22803C24.2663 6.08862 22.7578 8.96348 22.7578 12.1926Z",
    fill: "#ED6100"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.9168 2.03467C30.5357 2.03467 28.348 2.85606 26.6162 4.2281C28.9649 6.08869 30.4732 8.96356 30.4732 12.1927C30.4732 15.4221 28.9647 18.2967 26.6162 20.1573C28.348 21.5293 30.5357 22.3505 32.9168 22.3505C38.5268 22.3505 43.0746 17.8027 43.0746 12.1927C43.0746 6.58271 38.5268 2.03489 32.9168 2.03489V2.03467Z",
    fill: "#F79F06"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3497_34965"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32.8578,
    height: 20.4545,
    fill: "white",
    transform: "translate(10.1816 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMasternew12);
export default __webpack_public_path__ + "static/media/masternew12.0392071310533bd75a5a1bcf8888d431.svg";
export { ForwardRef as ReactComponent };